/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Group';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const GroupIcon = withMuiAdapter(Base, 'Group');
